import { useState } from "react";
import "./Footer.css";

const APPS_SCRIPT_URL = "https://script.google.com/macros/s/AKfycbyCuCHxj0-OeITZuhWmVPIDJACJ5KpGUNbQKmYX1wrMLa3-RRs1kmV-L6RM5EARHI-y/exec";
const PHONE_RAW   = "+917347200037";
const PHONE_LABEL = "+91 7347 200 037";

const MANAV_PHONE_RAW   = "+919855705708";
const MANAV_PHONE_LABEL = "+91 98557 05708";


function PhoneActionSheet({ onClose, name, phoneRaw, phoneLabel }) {
  const copyNumber = () => {
    navigator.clipboard.writeText(phoneRaw).then(onClose);
  };
  const saveContact = () => {
    const vcard = `BEGIN:VCARD\nVERSION:3.0\nFN:${name}\nTEL;TYPE=WORK,VOICE:${phoneRaw}\nEND:VCARD`;
    const blob = new Blob([vcard], { type: "text/vcard" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = `${name.replace(/\s+/g, "")}.vcf`;
    a.click();
    onClose();
  };
  return (
    <div className="asheet__overlay" onClick={onClose}>
      <div className="asheet" onClick={(e) => e.stopPropagation()}>
        <div className="asheet__handle" />

        {/* Identity card */}
        <div className="asheet__id">
          <div className="asheet__id-icon">
            <i className="fa-solid fa-fire" />
          </div>
          <div>
            <p className="asheet__id-name">{name}</p>
            <p className="asheet__id-num">{phoneLabel}</p>
          </div>
        </div>

        {/* Action group */}
        <div className="asheet__group">
          <button className="asheet__action" onClick={() => { window.location.href = `tel:${phoneRaw}`; onClose(); }}>
            <span className="asheet__action-label">Call</span>
            <span className="asheet__action-icon asheet__action-icon--call">
              <i className="fa-solid fa-phone" />
            </span>
          </button>
          <div className="asheet__divider" />
          <button className="asheet__action" onClick={copyNumber}>
            <span className="asheet__action-label">Copy Number</span>
            <span className="asheet__action-icon">
              <i className="fa-solid fa-copy" />
            </span>
          </button>
          <div className="asheet__divider" />
          <button className="asheet__action" onClick={saveContact}>
            <span className="asheet__action-label">Save Contact</span>
            <span className="asheet__action-icon">
              <i className="fa-solid fa-address-card" />
            </span>
          </button>
        </div>

        {/* Cancel */}
        <button className="asheet__cancel" onClick={onClose}>
          Cancel
        </button>
      </div>
    </div>
  );
}

const Footer = () => {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [status, setStatus] = useState("idle"); // idle | sending | sent | error
  const [activePhone, setActivePhone] = useState(null); // null | "main" | "manav"

  const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!APPS_SCRIPT_URL) {
      console.error("REACT_APP_CONTACT_SCRIPT_URL is not set.");
      setStatus("error");
      return;
    }
    setStatus("sending");
    try {
      await fetch(APPS_SCRIPT_URL, {
        method: "POST",
        // no-cors: Apps Script doesn't send CORS headers; we can't read
        // the response but the script runs and processes the submission.
        mode: "no-cors",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      setStatus("sent");
      setForm({ name: "", email: "", message: "" });
    } catch {
      setStatus("error");
    }
  };

  return (
    <>
      <section id="contact" className="contact section">
        <div className="container contact__inner reveal">
          <div className="contact__copy">
            <span className="eyebrow">Let's build together</span>
            <h2 className="section-title">
              Ready to <span className="grad">expand your vision?</span>
            </h2>
            <p className="section-sub">
              Tell us about your product, team or hiring need. We'll get back within one business day.
            </p>

            <ul className="contact__list">
              <li>
                <i className="fa-solid fa-envelope" />
                <a href="mailto:virvijay37@gmail.com">
                  virvijay37@gmail.com
                </a>
              </li>
              <li>
                <i className="fa-solid fa-phone" />
                <button className="phone-trigger" onClick={() => setActivePhone("main")}>
                  {PHONE_LABEL}
                </button>
              </li>
              <li>
                <i className="fa-solid fa-phone" />
                <button className="phone-trigger" onClick={() => setActivePhone("manav")}>
                  Manav — {MANAV_PHONE_LABEL}
                </button>
              </li>
              <li>
                <i className="fa-solid fa-location-dot" />
                <span>
                  Choti Havali, Suncity 2 (Near Gurudwara Sahib), Rupnagar 140001, India
                </span>
              </li>
            </ul>
          </div>

          <form className="contact__form" onSubmit={onSubmit}>
            <label>
              <span>Your name</span>
              <input
                type="text"
                name="name"
                required
                placeholder="Jane Doe"
                value={form.name}
                onChange={onChange}
              />
            </label>
            <label>
              <span>Work email</span>
              <input
                type="email"
                name="email"
                required
                placeholder="jane@company.com"
                value={form.email}
                onChange={onChange}
              />
            </label>
            <label>
              <span>How can we help?</span>
              <textarea
                name="message"
                rows="4"
                required
                placeholder="Tell us about your project or hiring need…"
                value={form.message}
                onChange={onChange}
              />
            </label>
            <button
              type="submit"
              className="btn btn-primary contact__submit"
              disabled={status === "sending"}
            >
              {status === "sending" ? "Sending…" : <>Send message <i className="fa-solid fa-paper-plane" /></>}
            </button>
            {status === "sent" && (
              <p className="contact__note">
                <i className="fa-solid fa-circle-check" />
                Message sent! We'll get back to you within one business day.
              </p>
            )}
            {status === "error" && (
              <p className="contact__note contact__note--error">
                <i className="fa-solid fa-circle-exclamation" />
                Something went wrong. Email us directly at{" "}
                <a href="mailto:virvijay37@gmail.com">virvijay37@gmail.com</a>.
              </p>
            )}
          </form>
        </div>
      </section>

      <footer className="footer">
        <div className="container footer__grid">
          <div className="footer__col footer__col--brand">
            <a href="#home" className="footer__brand">
              <span className="nav__mark" aria-hidden="true">
                <span className="nav__spark" />
              </span>
              <span className="nav__name">
                Ant<span className="nav__name-accent">Fire</span> Labs
              </span>
            </a>
            <p>
              A global IT business consulting and staffing partner — enabling organizations to
              expertly steer through their digital journey.
            </p>
            <div className="footer__social">
              <a href="#home" aria-label="Facebook"><i className="fab fa-facebook-f" /></a>
              <a href="#home" aria-label="Twitter"><i className="fab fa-twitter" /></a>
              <a href="#home" aria-label="WhatsApp"><i className="fab fa-whatsapp" /></a>
              <a href="#home" aria-label="LinkedIn"><i className="fab fa-linkedin-in" /></a>
            </div>
          </div>

          <div className="footer__col">
            <h4>Office</h4>
            <p>Choti Havali</p>
            <p>Suncity 2 (Near Gurudwara Sahib)</p>
            <p>Rupnagar, PIN 140001, India</p>
          </div>

          <div className="footer__col">
            <h4>Navigate</h4>
            <ul>
              <li><a href="#home">Home</a></li>
              <li><a href="#services">Services</a></li>
              <li><a href="#why">Why Us</a></li>
              <li><a href="#clients">Clients</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </div>

          <div className="footer__col">
            <h4>Reach us</h4>
            <p className="footer__email">
              <a href="mailto:virvijay37@gmail.com">
                virvijay37@gmail.com
              </a>
            </p>
            <p>
              <button className="phone-trigger" onClick={() => setActivePhone("main")}>
                {PHONE_LABEL}
              </button>
            </p>
            <p>
              <button className="phone-trigger" onClick={() => setActivePhone("manav")}>
                Manav — {MANAV_PHONE_LABEL}
              </button>
            </p>
          </div>
        </div>

        <div className="container footer__base">
          <p>© {new Date().getFullYear()} Ant Fire Labs. All rights reserved.</p>
          <p>Built with care in India · Serving clients globally</p>
        </div>
      </footer>

      {activePhone === "main" && (
        <PhoneActionSheet
          onClose={() => setActivePhone(null)}
          name="AntFire Labs"
          phoneRaw={PHONE_RAW}
          phoneLabel={PHONE_LABEL}
        />
      )}
      {activePhone === "manav" && (
        <PhoneActionSheet
          onClose={() => setActivePhone(null)}
          name="Manav"
          phoneRaw={MANAV_PHONE_RAW}
          phoneLabel={MANAV_PHONE_LABEL}
        />
      )}
    </>
  );
};

export default Footer;
